import { render, staticRenderFns } from "./IconWithText.vue?vue&type=template&id=46377e54&"
import script from "./IconWithText.vue?vue&type=script&lang=js&"
export * from "./IconWithText.vue?vue&type=script&lang=js&"
import style0 from "./IconWithText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46377e54')) {
      api.createRecord('46377e54', component.options)
    } else {
      api.reload('46377e54', component.options)
    }
    module.hot.accept("./IconWithText.vue?vue&type=template&id=46377e54&", function () {
      api.rerender('46377e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/IconWithText.vue"
export default component.exports